import Icon from '@atoms/Icon/Icon';
import { IUSPs } from '@models/IUSPs';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';
import { forwardRef } from 'react';

interface Props extends IUSPs {
  readonly isStripLoading: boolean;
  readonly isTouchDevice?: boolean;
}

const USPsFitStrip = forwardRef<HTMLDivElement, Props>(
  ({ items, isStripLoading, isTouchDevice }, stripWrapperRef) => {
    const isMobile = useMediaQuery(1024);

    return (
      <div
        className={classNames('flex px-7.5', {
          'overflow-hidden': isStripLoading,
        })}
        data-testid="CT-141-USPs-Strip-Wrapper"
      >
        <div
          ref={stripWrapperRef}
          className="flex h-10 w-full items-center justify-center gap-x-15"
        >
          {items.map((item, index) => (
            <a
              key={item.title}
              href={item.link?.url}
              target={item.link?.target}
              className={classNames('flex h-full items-center gap-x-2.5', {
                'pointer-events-none': !item.link?.url || isStripLoading,
                'hover:underline': !isTouchDevice && !isStripLoading,
              })}
              data-testid={`CT-141-USPs-Strip-Item-${index}`}
            >
              <Icon
                name={item.icon}
                size="1.25rem"
                colorClassName={isStripLoading ? 'text-grey-600' : 'text-white'}
              />

              <p
                className={classNames(
                  `flex items-center ${
                    isMobile ? 'body-four' : 'body-three'
                  } whitespace-nowrap`,
                  {
                    'text-grey-600': isStripLoading,
                  }
                )}
                data-testid={`CT-141-USPs-Strip-Item-Title-${index}`}
              >
                {item.title}
              </p>
            </a>
          ))}
        </div>
      </div>
    );
  }
);

export default USPsFitStrip;
